(function () {
  'use strict';

  var STORAGE_KEY = 'tepo:compare-products';
  var MAX = 4;
  var CHANGE_EVENT = 'compare:change';
  var activeSlotIndex = null;
  var activePickerAnchor = null;
  var compareScrollGuardActive = false;
  var compareTouchLastY = null;

  function isProductPage() {
    if (window.tepoIsProductPage === true) return true;
    return !!document.querySelector('.shopify-section--main-product') ||
      /\/products\/[^/?#]+/.test(window.location.pathname);
  }

  function isCompareBarAllowedPage() {
    return window.tepoCompareAllowed === true;
  }

  function isCompareCheckboxAllowedPage() {
    return window.tepoCompareCheckboxAllowed === true;
  }

  function syncCompareCheckboxVisibility() {
    var show = isCompareCheckboxAllowedPage();
    document.querySelectorAll('[data-compare-checkbox-wrap]').forEach(function (wrap) {
      wrap.hidden = !show;
    });
  }

  function compareProductsPageUrl() {
    var base = window.comparePageUrl || '/pages/compare-products';
    try {
      var url = new URL(base, window.location.origin);
      return url.pathname;
    } catch (e) {
      return '/pages/compare-products';
    }
  }

  function isCompareProductsPage() {
    if (window.tepoIsCompareProductsPage === true) return true;
    try {
      var path = window.location.pathname.replace(/\/+$/, '');
      var comparePath = new URL(window.comparePageUrl || '/pages/compare-products', window.location.origin)
        .pathname.replace(/\/+$/, '');
      return path === comparePath;
    } catch (e) {
      return /\/pages\/compare-products$/.test(window.location.pathname.replace(/\/+$/, ''));
    }
  }

  function getVisibleViewport() {
    var vv = window.visualViewport;
    if (!vv) {
      return {
        top: 0,
        left: 0,
        width: window.innerWidth,
        height: window.innerHeight
      };
    }
    return {
      top: vv.offsetTop,
      left: vv.offsetLeft,
      width: vv.width,
      height: vv.height
    };
  }

  function isMobilePicker() {
    return window.innerWidth < 700;
  }

  function isComparePageEmpty() {
    return isCompareProductsPage() && CompareStore.count() === 0;
  }

  function shouldPortalComparePicker() {
    return isComparePageEmpty() && isMobilePicker();
  }

  function ensurePickerPortal(picker) {
    if (!picker || !shouldPortalComparePicker()) return;
    if (picker.parentElement === document.body) return;
    picker._comparePickerHome = picker.parentElement;
    document.body.appendChild(picker);
  }

  function restorePickerPortal(picker) {
    if (!picker || !picker._comparePickerHome) return;
    if (picker._comparePickerHome.isConnected) {
      picker._comparePickerHome.appendChild(picker);
    } else {
      picker.remove();
    }
    picker._comparePickerHome = null;
  }

  var comparePageScrollLockY = 0;
  var comparePageScrollLocked = false;

  function lockComparePageScroll() {
    if (!shouldPortalComparePicker() || comparePageScrollLocked) return;
    var tableTarget = document.querySelector('[data-compare-page-table]') ||
      document.querySelector('[data-compare-page]');
    if (tableTarget) {
      var stickyTop = resolveStickyAreaHeight();
      var alignY = tableTarget.getBoundingClientRect().top + window.scrollY - stickyTop - 8;
      if (alignY < 0) alignY = 0;
      window.scrollTo(0, alignY);
      comparePageScrollLockY = alignY;
    } else {
      comparePageScrollLockY = window.scrollY;
    }
    comparePageScrollLocked = true;
    document.body.classList.add('is-compare-page-picking');
    document.body.style.position = 'fixed';
    document.body.style.top = (-comparePageScrollLockY) + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  }

  function unlockComparePageScroll() {
    document.body.classList.remove('is-compare-page-picking');
    if (!comparePageScrollLocked) return;
    comparePageScrollLocked = false;
    var y = comparePageScrollLockY;
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    restoreComparePageScroll(window.scrollX, y);
  }

  function restoreComparePageScroll(x, y) {
    if (!isCompareProductsPage()) return;
    function apply() {
      window.scrollTo(x, y);
    }
    apply();
    requestAnimationFrame(apply);
    setTimeout(apply, 0);
    setTimeout(apply, 100);
    setTimeout(apply, 300);
  }

  function syncComparePageEmptyState(hasProducts) {
    if (!isCompareProductsPage()) return;
    var isEmpty = !hasProducts;
    var tableWrap = document.querySelector('[data-compare-page-table]');
    var section = document.querySelector('.shopify-section--compare-page');
    if (tableWrap) tableWrap.classList.toggle('is-compare-empty', isEmpty);
    if (section) section.classList.toggle('is-compare-empty', isEmpty);
  }

  function resolveStickyAreaHeight() {
    var probe = document.createElement('div');
    probe.style.cssText = 'position:absolute;visibility:hidden;pointer-events:none;height:var(--sticky-area-height,0px)';
    document.body.appendChild(probe);
    var height = probe.offsetHeight || 0;
    probe.remove();
    return height;
  }

  var pageStickySyncing = false;
  var pageStickyHideTimer = null;

  function getPageStickyEls() {
    return {
      wrap: document.querySelector('[data-compare-page-wrap]'),
      thead: document.querySelector('[data-compare-page-header]'),
      sticky: document.querySelector('[data-compare-sticky-header]'),
      scroller: document.querySelector('[data-compare-sticky-scroller]')
    };
  }

  function clearPageStickyHeader(immediate) {
    var els = getPageStickyEls();
    if (!els.sticky || !els.scroller) return;
    if (els.sticky.hidden && !els.sticky.classList.contains('is-visible')) return;

    if (pageStickyHideTimer) {
      clearTimeout(pageStickyHideTimer);
      pageStickyHideTimer = null;
    }

    els.sticky.classList.remove('is-visible');

    function finishClear() {
      els.sticky.hidden = true;
      els.sticky.style.cssText = '';
      els.scroller.innerHTML = '';
      if (els.wrap) els.wrap.style.paddingTop = '';
      pageStickyHideTimer = null;
    }

    if (immediate) {
      finishClear();
      return;
    }

    pageStickyHideTimer = setTimeout(finishClear, 300);
  }

  function showPageStickyHeader(forceRebuild) {
    var els = getPageStickyEls();
    if (!els.wrap || !els.thead || !els.sticky || !els.scroller) return;

    if (pageStickyHideTimer) {
      clearTimeout(pageStickyHideTimer);
      pageStickyHideTimer = null;
    }

    var alreadyVisible = els.sticky.classList.contains('is-visible') && !els.sticky.hidden;
    var needsBuild = els.sticky.hidden || forceRebuild || !els.scroller.firstChild;

    if (needsBuild) buildPageStickyClone();

    els.sticky.hidden = false;
    positionPageStickyHeader();
    syncPageStickyScroll('wrap');

    if (alreadyVisible && !forceRebuild) return;

    requestAnimationFrame(function () {
      els.sticky.classList.add('is-visible');
    });
  }

  function buildPageStickyClone() {
    var els = getPageStickyEls();
    if (!els.wrap || !els.thead || !els.sticky || !els.scroller) return null;

    var table = els.thead.closest('table');
    if (!table) return null;

    var cloneTable = document.createElement('table');
    cloneTable.className = table.className;
    var colgroup = table.querySelector('colgroup');
    if (colgroup) cloneTable.appendChild(colgroup.cloneNode(true));
    var cloneHead = els.thead.cloneNode(true);
    cloneHead.removeAttribute('data-compare-page-header');
    cloneTable.appendChild(cloneHead);
    els.scroller.innerHTML = '';
    els.scroller.appendChild(cloneTable);

    cloneTable.style.width = '';
    cloneTable.style.minWidth = '';
    cloneTable.style.maxWidth = '';
    var tableWidth = table.getBoundingClientRect().width;
    cloneTable.style.width = tableWidth + 'px';
    cloneTable.style.minWidth = tableWidth + 'px';

    return els;
  }

  function positionPageStickyHeader() {
    var els = getPageStickyEls();
    if (!els.wrap || !els.sticky || els.sticky.hidden) return;
    var rect = els.wrap.getBoundingClientRect();
    els.sticky.style.left = rect.left + 'px';
    els.sticky.style.width = rect.width + 'px';
  }

  function syncPageStickyScroll(from) {
    var els = getPageStickyEls();
    if (!els.wrap || !els.scroller || !els.sticky || els.sticky.hidden) return;
    if (pageStickySyncing) return;
    pageStickySyncing = true;
    if (from === 'wrap') {
      els.scroller.scrollLeft = els.wrap.scrollLeft;
    } else {
      els.wrap.scrollLeft = els.scroller.scrollLeft;
    }
    pageStickySyncing = false;
  }

  function syncPageHeaderStickyState(forceRebuild) {
    if (!isCompareProductsPage()) return;
    var els = getPageStickyEls();
    if (!els.wrap || !els.thead || !els.sticky) return;

    var stickyTop = resolveStickyAreaHeight();
    var theadRect = els.thead.getBoundingClientRect();
    var table = els.thead.closest('table');
    var tableBottom = table ? table.getBoundingClientRect().bottom : theadRect.bottom;
    var headerHeight = els.thead.offsetHeight || 0;
    var shouldStick =
      theadRect.top <= stickyTop + 1 &&
      tableBottom > stickyTop + headerHeight + 8;

    if (!shouldStick) {
      if (!els.sticky.hidden || els.sticky.classList.contains('is-visible')) {
        clearPageStickyHeader(false);
      }
      return;
    }

    if (els.sticky.classList.contains('is-visible') && !els.sticky.hidden && !forceRebuild) {
      positionPageStickyHeader();
      syncPageStickyScroll('wrap');
      if (getActivePicker()) positionActivePicker();
      return;
    }

    showPageStickyHeader(!!forceRebuild);
    if (getActivePicker()) positionActivePicker();
  }

  function refreshPageStickyCloneIfNeeded() {
    var els = getPageStickyEls();
    if (!els.sticky || els.sticky.hidden) return;
    syncPageHeaderStickyState(true);
  }

  function bindPageStickyScroll() {
    var els = getPageStickyEls();
    if (!els.wrap || !els.scroller || els.wrap.dataset.compareStickyBound) return;
    els.wrap.dataset.compareStickyBound = '1';
    els.wrap.addEventListener('scroll', function () {
      syncPageStickyScroll('wrap');
      if (getActivePicker()) positionActivePicker();
    }, { passive: true });
    els.scroller.addEventListener('scroll', function () {
      syncPageStickyScroll('scroller');
    }, { passive: true });
  }

  function initComparePage() {
    if (!isCompareProductsPage()) return;
    bindPageStickyScroll();
    renderPageCompare(CompareStore.get());
    syncPageHeaderStickyState();
  }

  var CompareStore = {
    get: function () {
      try {
        var raw = localStorage.getItem(STORAGE_KEY);
        var list = raw ? JSON.parse(raw) : [];
        return Array.isArray(list) ? list.slice(0, MAX) : [];
      } catch (e) {
        return [];
      }
    },

    set: function (items) {
      var next = (items || []).slice(0, MAX);
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
      } catch (e) {}
      document.dispatchEvent(new CustomEvent(CHANGE_EVENT, { detail: { items: next } }));
      return next;
    },

    add: function (product) {
      if (!product || product.id == null) return { ok: false, reason: 'invalid' };
      if (product.available === false) return { ok: false, reason: 'unavailable' };
      var items = this.get();
      if (items.some(function (p) { return String(p.id) === String(product.id); })) {
        return { ok: true, items: items, reason: 'exists' };
      }
      if (items.length >= MAX) return { ok: false, reason: 'max', items: items };
      items.push(normalizeProduct(product));
      return { ok: true, items: this.set(items) };
    },

    remove: function (id) {
      return this.set(this.get().filter(function (p) { return String(p.id) !== String(id); }));
    },

    clear: function () {
      return this.set([]);
    },

    count: function () {
      return this.get().length;
    }
  };

  window.CompareStore = CompareStore;

  function normalizeProduct(product) {
    var specs = product.specs || {};
    var normalized = {};
    Object.keys(specs).forEach(function (key) {
      var entry = specs[key];
      if (entry && typeof entry === 'object' && Object.prototype.hasOwnProperty.call(entry, 'v')) {
        normalized[key] = entry;
      } else {
        normalized[key] = { t: Array.isArray(entry) ? 'list' : typeof entry === 'boolean' ? 'boolean' : 'text', v: entry };
      }
    });
    return Object.assign({}, product, { specs: normalized });
  }

  function announce(msg) {
    var live = document.querySelector('[data-compare-live]');
    if (!live) return;
    live.textContent = '';
    requestAnimationFrame(function () { live.textContent = msg; });
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function parseProduct(input) {
    var sourceId = input.getAttribute('data-compare-source');
    if (sourceId) {
      var script = document.getElementById(sourceId);
      if (script) {
        try {
          return normalizeProduct(JSON.parse(script.textContent));
        } catch (e) {
          return null;
        }
      }
    }
    return null;
  }

  function isEmptySpec(entry) {
    if (!entry) return true;
    var value = entry.v;
    if (value == null || value === '') return true;
    if (Array.isArray(value) && !value.length) return true;
    return false;
  }

  function formatSpecCell(entry) {
    if (isEmptySpec(entry)) {
      return '<span class="product-comparison__empty">-</span>';
    }

    var type = entry.t;
    var value = entry.v;
    var assets = window.compareAssets || {};
    var rgb = assets.textColorRgb || '26, 26, 26';
    var trueIcon = assets.trueIcon || '';
    var falseIcon =
      '<svg fill="none" class="icon offset-icon" width="16" height="16" viewBox="0 0 16 16" style="--icon-height: 16px">' +
      '<path d="m.94 3.06 12 12 2.12-2.12-12-12L.94 3.06Zm2.12 12 12-12L12.94.94l-12 12 2.12 2.12Z" fill="rgb(' +
      escapeHtml(rgb) + ')"></path></svg>';
    var trueImg = trueIcon
      ? '<img class="product-comparison__true" src="' + escapeHtml(trueIcon) + '" alt="" width="20" height="20" loading="lazy">'
      : '<span class="cpc-page__check">✓</span>';

    if (type === 'boolean') {
      if (value === true) return trueImg;
      if (value === false) return falseIcon;
      return '<span class="product-comparison__empty">-</span>';
    }

    if (type === 'list' && Array.isArray(value)) {
      if (value.length === 1) {
        return '<span class="compare-bar__list-single">' + escapeHtml(value[0]) + '</span>';
      }
      if (value.length > 1) {
        return '<ul class="compare-bar__list">' +
          value.map(function (item) {
            return '<li class="compare-bar__list-item">' + escapeHtml(item) + '</li>';
          }).join('') +
          '</ul>';
      }
      return '<span class="product-comparison__empty">-</span>';
    }

    var normalized = String(value).trim().toLowerCase();
    if (normalized === 'false' || normalized === 'no') return falseIcon;
    if (normalized === 'true' || normalized === 'yes') return trueImg;
    return escapeHtml(value);
  }

  function syncCheckboxes(items) {
    var ids = {};
    (items || CompareStore.get()).forEach(function (p) {
      ids[String(p.id)] = true;
    });
    document.querySelectorAll('[data-compare-toggle]').forEach(function (input) {
      var id = String(input.value);
      var unavailable = input.hasAttribute('data-compare-unavailable');
      input.checked = unavailable ? false : !!ids[id];
      input.disabled = unavailable || (!input.checked && CompareStore.count() >= MAX);
      var label = input.closest('[data-compare-checkbox]');
      if (label) {
        label.classList.toggle('is-checked', input.checked);
        label.classList.toggle('is-disabled', input.disabled);
        var wrap = label.closest('[data-compare-checkbox-wrap]');
        var maxFull = wrap
          ? wrap.querySelector('[data-compare-max-full]')
          : null;
        if (maxFull) {
          maxFull.hidden = unavailable || !!input.checked || CompareStore.count() < MAX;
        }
        var status = wrap ? wrap.querySelector('[data-compare-status]') : null;
        var pdpView = wrap ? wrap.querySelector('[data-compare-pdp-view]') : null;
        if (status) {
          status.hidden = unavailable || !input.checked;
        }
        if (pdpView) {
          pdpView.hidden = unavailable || !!input.checked;
        }
      }
    });
  }

  function isDrawerOpen() {
    var bar = document.querySelector('[data-compare-bar]');
    return !!(bar && bar.classList.contains('is-drawer-open'));
  }

  function syncStickyProductRowState() {
    var bar = document.querySelector('[data-compare-bar]');
    if (!bar || bar.hidden || !bar.classList.contains('is-page-section')) return;
    var wrap = bar.querySelector('[data-compare-drawer]');
    var head = bar.querySelector('.compare-bar__products-row');
    var corner = bar.querySelector('.compare-bar__table--page .compare-bar__corner');
    if (!wrap || !head) return;

    var stickyTop = parseFloat(getComputedStyle(wrap).top) || 0;
    var wrapRect = wrap.getBoundingClientRect();
    var section = bar.closest('.cpc-section') ||
      document.querySelector('.cpc-section');
    var sectionBottom = section ? section.getBoundingClientRect().bottom : wrapRect.bottom;
    var isStuck = wrapRect.top <= stickyTop + 1 && sectionBottom > stickyTop + 1;

    head.classList.toggle('sticky', isStuck);
    if (corner) corner.classList.toggle('sticky', isStuck);
    bar.classList.toggle('is-products-row-stuck', isStuck);
    syncEmptyProductHeights();
  }

  function openDrawer(options) {
    var bar = document.querySelector('[data-compare-bar]');
    var minCount = options && options.minCount != null ? options.minCount : 2;
    var keepPicker = !!(options && options.keepPicker);
    if (!bar || CompareStore.count() < minCount) return false;
    bar.classList.remove('is-collapsed');
    bar.classList.add('is-drawer-open');
    var drawer = bar.querySelector('[data-compare-drawer]');
    var compact = bar.querySelector('[data-compare-compact]');
    var collapseBtn = bar.querySelector('[data-compare-collapse]');
    var submitBtn = bar.querySelector('[data-compare-submit]');
    var clearBtn = bar.querySelector('[data-compare-clear]');
    if (drawer) drawer.hidden = false;
    if (compact) compact.hidden = true;
    if (collapseBtn) collapseBtn.hidden = false;
    if (submitBtn) submitBtn.hidden = true;
    if (clearBtn) clearBtn.hidden = true;
    var toggle = bar.querySelector('[data-compare-bar-toggle]');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
    renderDrawer(CompareStore.get());
    requestAnimationFrame(function () {
      if (!isCompareProductsPage()) syncStickyProductRowState();
    });
    updateBarOffset();
    syncCompareOverlays();
    if (!keepPicker) closePicker();
    return true;
  }

  function slideBarDown(bar, cb) {
    bar.classList.remove('is-visible', 'is-drawer-open', 'is-collapsed');
    function done() {
      bar.removeEventListener('transitionend', done);
      if (cb) cb();
    }
    bar.addEventListener('transitionend', done);
    setTimeout(done, 600);
  }

  function closeDrawer() {
    var bar = document.querySelector('[data-compare-bar]');
    if (!bar) return;
    bar.classList.remove('is-drawer-open');
    bar.classList.remove('is-products-row-stuck');
    var head = bar.querySelector('.compare-bar__products-row');
    var corner = bar.querySelector('.compare-bar__table--page .compare-bar__corner');
    if (head) head.classList.remove('sticky');
    if (corner) corner.classList.remove('sticky');
    var drawer = bar.querySelector('[data-compare-drawer]');
    var compact = bar.querySelector('[data-compare-compact]');
    var collapseBtn = bar.querySelector('[data-compare-collapse]');
    var submitBtn = bar.querySelector('[data-compare-submit]');
    var clearBtn = bar.querySelector('[data-compare-clear]');
    if (drawer) drawer.hidden = true;
    if (compact) compact.hidden = false;
    if (collapseBtn) collapseBtn.hidden = true;
    if (submitBtn) submitBtn.hidden = false;
    if (clearBtn) clearBtn.hidden = false;
    updateBarOffset();
    syncCompareOverlays();
  }

  function bagIconSvg() {
    return (
      '<svg class="compare-bar__bag-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" width="16" height="16" aria-hidden="true" focusable="false">' +
      '<path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path>' +
      '<line x1="3" y1="6" x2="21" y2="6"></line>' +
      '<path d="M16 10a4 4 0 0 1-8 0"></path>' +
      '</svg>'
    );
  }

  function emptyIconMarkup() {
    var moreIcon = window.compareAssets && window.compareAssets.moreIcon;
    if (moreIcon) {
      return '<img class="compare-bar__empty-icon" src="' + escapeHtml(moreIcon) + '" alt="" width="21" height="21">';
    }
    return '<span class="compare-bar__empty-icon" aria-hidden="true">+</span>';
  }

  function updateBarOffset() {
    var bar = document.querySelector('[data-compare-bar]');
    if (!bar || bar.hidden) {
      document.documentElement.style.setProperty('--compare-bar-offset', '0px');
      return;
    }
    if (isCompareProductsPage() && bar.classList.contains('is-page-section')) {
      document.documentElement.style.setProperty('--compare-bar-offset', '0px');
      return;
    }
    if (bar.classList.contains('is-drawer-open') && !bar.classList.contains('is-page-section')) {
      document.documentElement.style.setProperty('--compare-bar-offset', '0px');
      return;
    }
    document.documentElement.style.setProperty(
      '--compare-bar-offset',
      (bar.offsetHeight || 160) + 'px'
    );
  }

  function isOverlayDrawerScrollLock() {
    if (isCompareProductsPage()) return false;
    var bar = document.querySelector('[data-compare-bar]');
    return !!(
      bar &&
      !bar.hidden &&
      bar.classList.contains('is-visible') &&
      bar.classList.contains('is-drawer-open') &&
      !bar.classList.contains('is-page-section')
    );
  }

  function getCompareScrollContainer(target) {
    var node = target;
    while (node && node !== document.documentElement) {
      if (!node.closest || !node.closest('[data-compare-bar]')) return null;
      if (
        node.matches &&
        node.matches(
          '.compare-picker__results, .compare-bar__panel, [data-compare-picker], .compare-bar__table-wrap'
        ) &&
        node.scrollHeight > node.clientHeight + 1
      ) {
        return node;
      }
      node = node.parentElement;
    }
    return null;
  }

  function canScrollY(el, deltaY) {
    if (!el || !deltaY) return false;
    if (deltaY < 0) return el.scrollTop > 0;
    return el.scrollTop + el.clientHeight < el.scrollHeight - 1;
  }

  function onCompareScrollGuard(event) {
    if (!isOverlayDrawerScrollLock()) return;

    if (event.type === 'wheel') {
      var deltaY = event.deltaY || 0;
      var container = getCompareScrollContainer(event.target);
      if (container && canScrollY(container, deltaY)) return;
      event.preventDefault();
      return;
    }

    if (event.type === 'touchmove') {
      var touch = event.touches && event.touches[0];
      if (!touch || compareTouchLastY == null) {
        event.preventDefault();
        return;
      }
      var touchDeltaY = compareTouchLastY - touch.clientY;
      compareTouchLastY = touch.clientY;
      if (!touchDeltaY) return;
      var touchContainer = getCompareScrollContainer(event.target);
      if (touchContainer && canScrollY(touchContainer, touchDeltaY)) return;
      event.preventDefault();
    }
  }

  function onCompareTouchStart(event) {
    if (!isOverlayDrawerScrollLock()) return;
    var touch = event.touches && event.touches[0];
    compareTouchLastY = touch ? touch.clientY : null;
  }

  function onCompareTouchEnd() {
    compareTouchLastY = null;
  }

  function onCompareKeyScrollGuard(event) {
    if (!isOverlayDrawerScrollLock()) return;
    if (event.target && event.target.closest && event.target.closest('[data-compare-bar]')) return;
    if (event.key !== ' ' && event.key !== 'PageUp' && event.key !== 'PageDown' &&
      event.key !== 'Home' && event.key !== 'End' &&
      event.key !== 'ArrowUp' && event.key !== 'ArrowDown') {
      return;
    }
    event.preventDefault();
  }

  function syncCompareScrollGuard() {
    var shouldGuard = isOverlayDrawerScrollLock();
    if (shouldGuard === compareScrollGuardActive) return;
    compareScrollGuardActive = shouldGuard;
    if (shouldGuard) {
      document.addEventListener('wheel', onCompareScrollGuard, { passive: false, capture: true });
      document.addEventListener('touchstart', onCompareTouchStart, { passive: true, capture: true });
      document.addEventListener('touchmove', onCompareScrollGuard, { passive: false, capture: true });
      document.addEventListener('touchend', onCompareTouchEnd, { passive: true, capture: true });
      document.addEventListener('touchcancel', onCompareTouchEnd, { passive: true, capture: true });
      document.addEventListener('keydown', onCompareKeyScrollGuard, true);
      return;
    }
    document.removeEventListener('wheel', onCompareScrollGuard, true);
    document.removeEventListener('touchstart', onCompareTouchStart, true);
    document.removeEventListener('touchmove', onCompareScrollGuard, true);
    document.removeEventListener('touchend', onCompareTouchEnd, true);
    document.removeEventListener('touchcancel', onCompareTouchEnd, true);
    document.removeEventListener('keydown', onCompareKeyScrollGuard, true);
    compareTouchLastY = null;
  }

  function syncCompareOverlays() {
    var bar = document.querySelector('[data-compare-bar]');
    var visible = !!(bar && !bar.hidden && bar.classList.contains('is-visible'));
    var drawerOpen = visible && bar.classList.contains('is-drawer-open');
    var collapsed = visible && !drawerOpen && bar.classList.contains('is-collapsed');
    var hideTrustbadge = visible && !collapsed;
    var root = document.documentElement;
    var lift = 0;

    if (visible && !drawerOpen) {
      lift = Math.round(bar.offsetHeight || bar.getBoundingClientRect().height || 0) + 15;
    }

    root.classList.toggle('tepo-compare-open', visible);
    root.classList.toggle('tepo-compare-drawer-open', drawerOpen);
    root.classList.toggle('tepo-compare-collapsed', collapsed);
    root.classList.toggle('tepo-compare-hide-trustbadge', hideTrustbadge);
    root.style.setProperty('--compare-floating-lift', lift + 'px');

    document.dispatchEvent(new CustomEvent('tepo:compare-overlay-change', {
      detail: {
        visible: visible,
        drawerOpen: drawerOpen,
        collapsed: collapsed,
        hideTrustbadge: hideTrustbadge,
        lift: lift
      }
    }));

    if (typeof window.tepoSyncTrustBadge === 'function') {
      window.tepoSyncTrustBadge();
    }

    syncCompareScrollGuard();
  }

  function renderPriceList(product, extraClass) {
    if (!product || !product.price) return '';
    var onSale = !!product.compareAtPrice;
    var classes = 'price-list' + (extraClass ? ' ' + extraClass : '');
    if (onSale) {
      return (
        '<price-list class="' + classes + '">' +
        '<sale-price class="text-on-sale">' +
        '<span class="sr-only">Sale price</span>' +
        escapeHtml(product.price) +
        '</sale-price>' +
        '<compare-at-price class="text-subdued line-through">' +
        '<span class="sr-only">Regular price</span>' +
        escapeHtml(product.compareAtPrice) +
        '</compare-at-price>' +
        '</price-list>'
      );
    }
    return (
      '<price-list class="' + classes + '">' +
      '<sale-price class="text-subdued">' +
      '<span class="sr-only">Sale price</span>' +
      escapeHtml(product.price) +
      '</sale-price>' +
      '</price-list>'
    );
  }

  function renderSlots(items) {
    var i18n = window.compareI18n || {};
    document.querySelectorAll('[data-compare-slot]').forEach(function (slot, index) {
      var product = items[index];
      if (product) {
        slot.classList.add('compare-bar__slot--filled');
        slot.classList.remove('compare-bar__slot--empty');
        slot.innerHTML =
          '<div class="compare-bar__slot-inner">' +
          '<button type="button" class="compare-bar__remove" data-compare-remove="' +
          escapeHtml(product.id) +
          '" aria-label="' +
          escapeHtml(i18n.remove || 'Remove') +
          ': ' + escapeHtml(product.title) +
          '">' +
          closeIconMarkup('compare-bar__collapse-icon', 10) +
          '</button>' +
          (product.image
            ? '<img class="compare-bar__thumb" src="' + escapeHtml(product.image) +
              '" alt="" width="56" height="56" loading="lazy">'
            : '<div class="compare-bar__thumb compare-bar__thumb--placeholder"></div>') +
          '<div class="compare-bar__meta">' +
          '<p class="compare-bar__title">' + escapeHtml(product.title) + '</p>' +
          renderPriceList(product, 'compare-bar__price') +
          '</div></div>';
      } else {
        slot.classList.remove('compare-bar__slot--filled');
        slot.classList.add('compare-bar__slot--empty');
        slot.innerHTML =
          '<button type="button" class="compare-bar__add" data-compare-open-picker data-slot-index="' +
          index + '">' +
          emptyIconMarkup() +
          '<span class="compare-bar__empty-text">' +
          escapeHtml(i18n.selectAnother || 'Select another product') +
          '</span></button>' +
          pickerMarkup(index);
      }
    });
  }

  function renderProductHeaderCell(product, index, i18n) {
    if (product) {
      return (
        '<div class="compare-bar__product">' +
        (product.image
          ? '<img class="compare-bar__product-image" src="' + escapeHtml(product.image) + '" alt="' +
            escapeHtml(product.title) + '" width="140" height="140" loading="lazy">'
          : '<div class="compare-bar__product-image compare-bar__product-image--placeholder"></div>') +
        '<button type="button" class="compare-bar__remove" data-compare-remove="' +
        escapeHtml(product.id) + '" aria-label="' +
        escapeHtml(i18n.remove || 'Remove') + ': ' + escapeHtml(product.title) +
        '">' + closeIconMarkup('compare-bar__collapse-icon', 10) + '</button>' +
        '<a href="' + escapeHtml(product.url) + '" class="compare-bar__product-title">' +
        escapeHtml(product.title) + '</a>' +
        renderPriceList(product, 'compare-bar__product-pricing') +
        (product.available && product.variantId
          ? '<button type="button" class="compare-bar__product-atc-btn cts-btn-cart" data-compare-atc="' +
            escapeHtml(product.variantId) + '" aria-label="' +
            escapeHtml(i18n.addToCart || 'Add to cart') + '">' +
            bagIconSvg() +
            '<span class="compare-bar__product-atc-label">' +
            escapeHtml(i18n.addToCart || 'Add to cart') +
            '</span>' +
            '</button>'
          : '<span class="compare-bar__product-soldout">' +
            escapeHtml(i18n.soldOut || 'Sold out') + '</span>') +
        '</div>'
      );
    }

    return (
      '<div class="compare-bar__product compare-bar__product--empty" data-compare-open-picker data-slot-index="' +
      index + '" role="button" tabindex="0" aria-label="' +
      escapeHtml(i18n.addProduct || i18n.selectAnother || 'Add product') + '">' +
      emptySlotTriggerMarkup(i18n) +
      pickerMarkup(index) +
      '</div>'
    );
  }

  function renderBar(items) {
    var bar = document.querySelector('[data-compare-bar]');
    if (!bar) return;

    if (isCompareProductsPage()) {
      renderPageCompare(items);
      return;
    }

    if (!isCompareBarAllowedPage()) {
      bar.hidden = true;
      bar.classList.remove('is-visible', 'is-drawer-open', 'is-collapsed');
      updateBarOffset();
      syncCompareOverlays();
      return;
    }

    var count = items.length;

    if (count === 0) {
      if (bar.classList.contains('is-visible')) {
        slideBarDown(bar, function () {
          bar.hidden = true;
          updateBarOffset();
          syncCompareOverlays();
        });
        closePicker();
      } else {
        bar.hidden = true;
      }
      return;
    }

    bar.hidden = false;
    bar.classList.add('is-visible');

    var countEl = bar.querySelector('[data-compare-count]');
    if (countEl) countEl.textContent = count + '/' + MAX;

    var compareBtn = bar.querySelector('[data-compare-submit]');
    if (compareBtn) {
      var ready = count >= 2;
      compareBtn.disabled = !ready;
      compareBtn.setAttribute('aria-disabled', ready ? 'false' : 'true');
    }

    renderSlots(items);

    if (isDrawerOpen()) {
      if (count < 1) closeDrawer();
      else renderDrawer(items);
    }

    updateBarOffset();
    syncCompareOverlays();
  }

  function syncEmptyProductHeights() {
    if (isCompareProductsPage()) return;

    if (!isDrawerOpen()) return;
    var row = document.querySelector('.compare-bar__products-row');
    if (!row) return;

    var filled = row.querySelectorAll('.compare-bar__product:not(.compare-bar__product--empty)');
    var empties = row.querySelectorAll('.compare-bar__product--empty');
    if (!empties.length) return;

    var maxHeight = 0;
    filled.forEach(function (el) {
      el.style.minHeight = '';
      maxHeight = Math.max(maxHeight, el.offsetHeight);
    });
    if (maxHeight < 200) maxHeight = 200;

    var stuck = !!(
      document.querySelector('[data-compare-bar]') &&
      document.querySelector('[data-compare-bar]').classList.contains('is-products-row-stuck')
    );

    empties.forEach(function (el) {
      el.style.minHeight = stuck ? '' : maxHeight + 'px';
    });
  }

  function getPageCpc() {
    return {
      wrap: document.querySelector('[data-compare-page-wrap]') || null,
      header: document.querySelector('[data-compare-page-header]'),
      tbody: document.querySelector('[data-compare-tbody]')
    };
  }

  function renderPageCompare(items) {
    var p = getPageCpc();
    if (!p.header || !p.tbody) return;

    items = items || [];
    var hasProducts = items.length > 0;
    var tableWrap = document.querySelector('[data-compare-page-table]');
    var emptyEl = document.querySelector('[data-compare-empty]');
    var i18n = window.compareI18n || {};

    if (tableWrap) tableWrap.hidden = false;
    if (emptyEl) emptyEl.hidden = true;
    syncComparePageEmptyState(hasProducts);

    var slots = p.header.querySelectorAll('[data-compare-product-slot]');
    slots.forEach(function (cell, index) {
      var product = items[index];
      cell.classList.toggle('prod-compare__product-cell--empty', !product);
      cell.classList.toggle('prod-compare__product-cell--filled', !!product);
      cell.innerHTML = renderPageProductCell(product, index, i18n);
    });

    if (!hasProducts) {
      p.tbody.innerHTML = '';
      refreshPageStickyCloneIfNeeded();
      syncPageHeaderStickyState();
      return;
    }

    var rows = window.compareRows || [];

    var body = '';
    rows.forEach(function (row) {
      var allEmpty = items.length > 0 && items.every(function (prod) {
        return isEmptySpec(prod && prod.specs && prod.specs[row.key]);
      });
      if (allEmpty) return;

      body += '<tr class="prod-compare__spec-row">';
      body += '<th class="prod-compare__spec-label" scope="row"><span class="prod-compare__spec-label-inner">' +
        escapeHtml(row.label || row.key) + '</span></th>';
      for (var c = 0; c < MAX; c++) {
        var prod = items[c];
        body += '<td class="prod-compare__spec-value">';
        body += prod ? formatSpecCell(prod.specs && prod.specs[row.key]) : '';
        body += '</td>';
      }
      body += '</tr>';
    });

    p.tbody.innerHTML = body ||
      '<tr class="prod-compare__spec-row"><td colspan="' + (MAX + 1) + '" class="compare-bar__no-specs">' +
      escapeHtml(i18n.noSpecs || 'No specifications available.') + '</td></tr>';

    refreshPageStickyCloneIfNeeded();
    syncPageHeaderStickyState();
  }

  function renderPageProductCell(product, index, i18n) {
    if (product) {
      return (
        '<button type="button" class="compare-bar__remove" data-compare-remove="' +
        escapeHtml(product.id) + '" aria-label="' +
        escapeHtml(i18n.remove || 'Remove') + ': ' + escapeHtml(product.title) +
        '">' + closeIconMarkup('compare-bar__collapse-icon', 10) + '</button>' +
        '<div class="compare-bar__product-cell-inner">' +
        '<div class="compare-bar__product">' +
        (product.image
          ? '<img class="compare-bar__product-image" src="' + escapeHtml(product.image) + '" alt="' +
            escapeHtml(product.title) + '" width="140" height="140" loading="lazy">'
          : '<div class="compare-bar__product-image compare-bar__product-image--placeholder"></div>') +
        '<div class="compare-bar__product-info">' +
        '<a href="' + escapeHtml(product.url) + '" class="compare-bar__product-title">' +
        escapeHtml(product.title) + '</a>' +
        renderPriceList(product, 'compare-bar__product-pricing') +
        (!product.available
          ? '<span class="compare-bar__product-soldout">' +
            escapeHtml(i18n.soldOut || 'Sold out') + '</span>'
          : '') +
        '</div>' +
        '</div>' +
        (product.available && product.variantId
          ? '<button type="button" class="compare-bar__product-atc-btn cts-btn-cart" data-compare-atc="' +
            escapeHtml(product.variantId) + '" aria-label="' +
            escapeHtml(i18n.addToCart || 'Add to cart') + '">' +
            bagIconSvg() +
            '<span class="compare-bar__product-atc-label">' +
            escapeHtml(i18n.addToCart || 'Add to cart') + '</span></button>'
          : '') +
        '</div>'
      );
    }
    return (
      '<div class="empty___cell" data-compare-open-picker data-slot-index="' +
      index + '" role="button" tabindex="0" aria-label="' +
      escapeHtml(i18n.addProduct || i18n.selectAnother || 'Add product') + '">' +
      emptySlotTriggerMarkup(i18n) +
      pickerMarkup(index) +
      '</div>'
    );
  }

  function renderDrawer(items) {
    if (isCompareProductsPage()) {
      renderPageCompare(items);
      return;
    }

    var productSlots = document.querySelectorAll('[data-compare-product-slot]');
    var tbody = document.querySelector('[data-compare-tbody]');
    var rows = window.compareRows || [];
    var i18n = window.compareI18n || {};

    productSlots.forEach(function (cell, index) {
      var product = items[index];
      cell.classList.toggle('compare-bar__product-cell--empty', !product);
      cell.classList.toggle('compare-bar__product-cell--filled', !!product);
      cell.innerHTML = renderProductHeaderCell(product, index, i18n);
    });

    if (tbody) {
      var body = '';
      rows.forEach(function (row) {
        var allEmpty = items.every(function (prod) {
          return isEmptySpec(prod.specs && prod.specs[row.key]);
        });
        if (allEmpty) return;

        body += '<tr class="compare-bar__spec-row" data-compare-row>';
        body += '<th class="compare-bar__spec-label sticky" scope="row">' +
          '<span class="compare-bar__spec-label-inner">' +
          escapeHtml(row.label || row.key) + '</span></th>';
        for (var c = 0; c < MAX; c++) {
          var prod = items[c];
          body += '<td class="compare-bar__spec-value">';
          body += prod
            ? formatSpecCell(prod.specs && prod.specs[row.key])
            : '';
          body += '</td>';
        }
        body += '</tr>';
      });

      tbody.innerHTML = body ||
        '<tr><td colspan="' + (MAX + 1) + '" class="compare-bar__no-specs">' +
        escapeHtml(i18n.noSpecs || 'No specifications available.') +
        '</td></tr>';
    }

    requestAnimationFrame(function () {
      syncEmptyProductHeights();
      syncStickyProductRowState();
    });
  }

  function getCatalog() {
    return Array.isArray(window.compareCameraCatalog) ? window.compareCameraCatalog : [];
  }

  function isEligibleProduct(product) {
    if (!product) return false;
    if (product.available === false) return false;
    var catalog = getCatalog();
    if (!catalog.length) return false;
    var match = catalog.find(function (p) { return String(p.id) === String(product.id); });
    if (!match) return false;
    if (match.available === false) return false;
    return true;
  }

  function pruneIneligible(items) {
    var next = (items || []).filter(isEligibleProduct);
    if (next.length !== (items || []).length) {
      return CompareStore.set(next);
    }
    return next;
  }

  function emptySlotTriggerMarkup(i18n) {
    return (
      '<div class="compare-picker-anchor" data-compare-picker-anchor>' +
      emptyIconMarkup() +
      '<span class="compare-bar__product-add">' +
      escapeHtml(i18n.addProduct || i18n.selectAnother || 'Add product') +
      '</span></div>'
    );
  }

  function normalizePickerHost(host) {
    if (!host) return null;
    if (host.matches('[data-compare-picker-anchor]')) {
      return host.closest('.empty___cell, .compare-bar__product--empty');
    }
    if (host.matches('.empty___cell, .compare-bar__product--empty')) return host;
    if (host.matches('[data-compare-product-slot], [data-compare-slot]')) {
      return host.querySelector('.empty___cell, .compare-bar__product--empty');
    }
    return host.closest('.empty___cell, .compare-bar__product--empty');
  }

  function resolvePickerPlacement() {
    var slotIndex = activeSlotIndex;
    var els = getPageStickyEls();
    var stickyVisible = !!(
      els.sticky &&
      !els.sticky.hidden &&
      els.sticky.classList.contains('is-visible')
    );
    var emptyBox = null;
    var anchorEl = null;

    if (stickyVisible && slotIndex != null) {
      emptyBox = els.scroller.querySelector(
        '[data-compare-product-slot][data-slot-index="' + slotIndex + '"] .empty___cell, ' +
        '[data-compare-product-slot][data-slot-index="' + slotIndex + '"] .compare-bar__product--empty'
      );
    }

    if (!emptyBox && activePickerAnchor && activePickerAnchor.isConnected) {
      emptyBox = normalizePickerHost(activePickerAnchor);
    }

    if (!emptyBox) {
      emptyBox = document.querySelector(
        '.empty___cell.is-picker-open, .compare-bar__product--empty.is-picker-open'
      );
    }

    if (emptyBox) anchorEl = emptyBox.querySelector('[data-compare-picker-anchor]');

    if (!anchorEl) {
      anchorEl = document.querySelector(
        '.empty___cell.is-picker-open [data-compare-picker-anchor], ' +
        '.compare-bar__product--empty.is-picker-open [data-compare-picker-anchor]'
      );
      if (anchorEl && !emptyBox) {
        emptyBox = anchorEl.closest('.empty___cell, .compare-bar__product--empty');
      }
    }

    var anchorRect = anchorEl
      ? anchorEl.getBoundingClientRect()
      : (emptyBox ? emptyBox.getBoundingClientRect() : null);
    var boxRect = emptyBox ? emptyBox.getBoundingClientRect() : anchorRect;
    var cell = emptyBox
      ? (emptyBox.closest('[data-compare-product-slot], [data-compare-slot]') || emptyBox)
      : null;
    var cellRect = cell ? cell.getBoundingClientRect() : boxRect;

    return {
      emptyBox: emptyBox,
      anchorRect: anchorRect,
      boxRect: boxRect,
      cellRect: cellRect
    };
  }

  function closeIconMarkup(className, size) {
    var assets = window.compareAssets || {};
    var src = assets.closeIcon || '';
    var cls = className || 'compare-picker__close-icon';
    var dim = size || 14;
    if (!src) return '&times;';
    return (
      '<img class="' + escapeHtml(cls) + '" src="' + escapeHtml(src) +
      '" alt="" width="' + dim + '" height="' + dim + '" loading="lazy">'
    );
  }

  function pickerMarkup(slotIndex) {
    var i18n = window.compareI18n || {};
    var placeholder = escapeHtml(i18n.searchPlaceholder || 'Search products');
    var closeLabel = escapeHtml(i18n.close || 'Close');
    return (
      '<div class="compare-picker" data-compare-picker data-slot-index="' + slotIndex + '" hidden>' +
      '<div class="compare-picker__inner">' +
      '<div class="compare-picker__search">' +
      '<input type="search" class="compare-picker__input" data-compare-search' +
      ' placeholder="' + placeholder + '"' +
      ' aria-label="' + placeholder + '"' +
      ' autocomplete="off">' +
      '<button type="button" class="compare-picker__close" data-compare-close-picker' +
      ' aria-label="' + closeLabel + '">' + closeIconMarkup() + '</button>' +
      '</div>' +
      '<ul class="compare-picker__results" data-compare-search-results role="listbox"></ul>' +
      '</div></div>'
    );
  }

  function getActivePicker() {
    if (activeSlotIndex == null) return null;
    var open = document.querySelector(
      '[data-compare-picker][data-slot-index="' + activeSlotIndex + '"]:not([hidden])'
    );
    if (open) return open;

    var candidates = document.querySelectorAll(
      '[data-compare-picker][data-slot-index="' + activeSlotIndex + '"]'
    );
    for (var i = 0; i < candidates.length; i++) {
      var picker = candidates[i];
      var host = picker.closest('[hidden], .compare-bar__compact[hidden], .compare-bar__drawer[hidden]');
      if (!host) return picker;
    }
    return candidates[0] || null;
  }

  function clearPickerPosition(picker) {
    if (!picker) return;
    picker.classList.remove('is-fixed');
    picker.style.position = '';
    picker.style.top = '';
    picker.style.left = '';
    picker.style.right = '';
    picker.style.bottom = '';
    picker.style.width = '';
    picker.style.maxWidth = '';
    picker.style.maxHeight = '';
    picker.style.zIndex = '';
    picker.style.display = '';
    picker.style.flexDirection = '';
    picker.style.overflow = '';
    var inner = picker.querySelector('.compare-picker__inner');
    if (inner) {
      inner.style.maxHeight = '';
      inner.style.height = '';
      inner.style.flex = '';
      inner.style.minHeight = '';
    }
  }

  function positionActivePicker() {
    var picker = getActivePicker();
    if (!picker || picker.hidden) return;

    if (!isDrawerOpen() && !isCompareProductsPage()) {
      clearPickerPosition(picker);
      return;
    }

    var placement = resolvePickerPlacement();
    if (!placement.anchorRect && !placement.boxRect) return;

    var emptyBox = placement.emptyBox;
    var anchorRect = placement.anchorRect || placement.boxRect;
    var boxRect = placement.boxRect || anchorRect;
    var cellRect = placement.cellRect || boxRect;
    var viewport = getVisibleViewport();
    var viewportBottom = viewport.top + viewport.height;
    var vw = window.innerWidth;
    var isMobile = isMobilePicker();
    var pad = isMobile ? 8 : 12;
    var preferFlushPlacement = !!emptyBox;
    var useEmptyPagePicker = isComparePageEmpty() && isMobile;

    var width;
    var left;
    if (preferFlushPlacement) {
      width = Math.min(boxRect.width, vw - pad * 2);
      left = Math.min(Math.max(pad, boxRect.left), vw - width - pad);
    } else if (isMobile) {
      width = Math.max(0, vw - pad * 2);
      left = pad;
    } else {
      width = Math.min(Math.max(cellRect.width, 280), Math.min(340, vw - pad * 2));
      left = Math.min(Math.max(pad, cellRect.left + (cellRect.width - width) / 2), vw - width - pad);
    }

    var preferredTop;
    preferredTop = preferFlushPlacement ? anchorRect.bottom : anchorRect.bottom + 2;
    var spaceBelow = Math.max(0, viewportBottom - preferredTop - pad);
    var spaceAbove = anchorRect.top - viewport.top - pad;
    var maxHeight;
    var openBelow;
    var mobileMax = useEmptyPagePicker
      ? Math.min(Math.floor(viewport.height * 0.85), 520)
      : Math.min(Math.floor(viewport.height * 0.75), 480);

    if (preferFlushPlacement) {
      var minPickerHeight = useEmptyPagePicker ? 200 : 160;
      maxHeight = Math.min(isMobile ? mobileMax : 480, Math.max(minPickerHeight, Math.floor(spaceBelow)));
      openBelow = true;
    } else {
      maxHeight = isMobile
        ? mobileMax
        : Math.min(Math.max(spaceBelow, spaceAbove, 280), 480);
      maxHeight = Math.max(240, maxHeight);
      openBelow = isMobile || spaceBelow >= Math.min(280, maxHeight) || spaceBelow >= spaceAbove;
    }

    picker.classList.toggle('is-empty-page-picker', useEmptyPagePicker);
    picker.classList.add('is-fixed');
    picker.style.position = 'fixed';
    picker.style.width = Math.round(width) + 'px';
    picker.style.maxWidth = 'calc(100vw - ' + (pad * 2) + 'px)';
    picker.style.left = Math.round(left) + 'px';
    picker.style.right = 'auto';
    picker.style.zIndex = useEmptyPagePicker ? '10050' : (isMobile ? '999' : '80');
    picker.style.display = preferFlushPlacement ? 'flex' : '';
    picker.style.flexDirection = preferFlushPlacement ? 'column' : '';
    picker.style.overflow = preferFlushPlacement ? 'hidden' : '';

    if (preferFlushPlacement) {
      picker.style.top = Math.round(preferredTop) + 'px';
      picker.style.bottom = 'auto';
      picker.style.maxHeight = Math.round(maxHeight) + 'px';
    } else if (openBelow) {
      var top = isMobile ? Math.max(viewport.top + pad, viewportBottom - maxHeight - pad) : preferredTop;
      if (!isMobile && top + maxHeight > viewportBottom - pad) {
        top = Math.max(viewport.top + pad, viewportBottom - maxHeight - pad);
      }
      picker.style.top = Math.round(top) + 'px';
      picker.style.bottom = 'auto';
      picker.style.maxHeight = '';
      picker.style.display = '';
      picker.style.flexDirection = '';
      picker.style.overflow = '';
    } else {
      picker.style.top = 'auto';
      picker.style.bottom = Math.round(window.innerHeight - anchorRect.top + 2) + 'px';
      picker.style.maxHeight = '';
      picker.style.display = '';
      picker.style.flexDirection = '';
      picker.style.overflow = '';
    }

    var inner = picker.querySelector('.compare-picker__inner');
    if (inner) {
      inner.style.maxHeight = Math.round(maxHeight) + 'px';
      inner.style.height = '';
      inner.style.flex = preferFlushPlacement ? '1 1 auto' : '';
      inner.style.minHeight = preferFlushPlacement ? '0' : '';
    }
  }

  function openPicker(slotIndex, anchor) {
    closePicker();
    activeSlotIndex = slotIndex;
    activePickerAnchor = anchor ? (normalizePickerHost(anchor) || anchor) : null;
    var picker = null;
    if (anchor) {
      picker = anchor.querySelector('[data-compare-picker]') ||
        (anchor.closest('[data-compare-slot], [data-compare-product-slot], .empty___cell, .compare-bar__product--empty') || anchor)
          .querySelector('[data-compare-picker]');
    }
    if (!picker) picker = getActivePicker();
    if (!picker) return;

    picker.hidden = false;
    var emptyHost = activePickerAnchor || picker.closest('.empty___cell, .compare-bar__product--empty');
    ensurePickerPortal(picker);
    if (emptyHost) {
      emptyHost.classList.add('is-picker-open');
      if (!activePickerAnchor) activePickerAnchor = emptyHost;
    }
    if (shouldPortalComparePicker()) {
      lockComparePageScroll();
    }
    var bar = document.querySelector('[data-compare-bar]');
    if (bar) bar.classList.add('is-picking');
    var input = picker.querySelector('[data-compare-search]');
    if (input) {
      input.value = '';
      try {
        input.focus({ preventScroll: true });
      } catch (err) {
        input.focus();
      }
    }
    renderPickerResults('');
    positionActivePicker();
    requestAnimationFrame(function () {
      positionActivePicker();
    });
  }

  function closePicker() {
    var openHost = activePickerAnchor;
    var activeEl = document.activeElement;
    if (activeEl && activeEl.closest && activeEl.closest('[data-compare-picker]')) {
      activeEl.blur();
    }
    document.querySelectorAll('[data-compare-picker]').forEach(function (picker) {
      picker.hidden = true;
      picker.classList.remove('is-empty-page-picker');
      clearPickerPosition(picker);
      restorePickerPortal(picker);
      var emptyHost = openHost || picker.closest('.empty___cell, .compare-bar__product--empty');
      if (emptyHost) emptyHost.classList.remove('is-picker-open');
    });
    var bar = document.querySelector('[data-compare-bar]');
    if (bar) bar.classList.remove('is-picking');
    activeSlotIndex = null;
    activePickerAnchor = null;
    document.querySelectorAll('body > [data-compare-picker]').forEach(function (orphan) {
      orphan.remove();
    });
    unlockComparePageScroll();
  }

  function renderPickerResults(query) {
    var picker = getActivePicker();
    if (!picker || picker.hidden) return;
    var list = picker.querySelector('[data-compare-search-results]');
    if (!list) return;
    var i18n = window.compareI18n || {};
    var selectedIds = {};
    CompareStore.get().forEach(function (p) { selectedIds[String(p.id)] = true; });
    var q = String(query || '').trim().toLowerCase();
    var matches = getCatalog().filter(function (p) {
      if (!p || selectedIds[String(p.id)]) return false;
      if (p.available === false) return false;
      if (!q) return true;
      return String(p.title || '').toLowerCase().indexOf(q) !== -1 ||
        String(p.handle || '').toLowerCase().indexOf(q) !== -1 ||
        String(p.description || '').toLowerCase().indexOf(q) !== -1;
    }).slice(0, 12);

    if (!matches.length) {
      list.innerHTML = '<li class="compare-picker__empty">' +
        escapeHtml(i18n.noResults || 'No products found') + '</li>';
      return;
    }

    list.innerHTML = matches.map(function (p) {
      return '<li>' +
        '<button type="button" class="compare-picker__item" data-compare-pick="' +
        escapeHtml(p.id) + '">' +
        (p.image
          ? '<img src="' + escapeHtml(p.image) + '" alt="" width="40" height="40" loading="lazy">'
          : '<span class="compare-picker__thumb" aria-hidden="true"></span>') +
        '<span class="compare-picker__meta">' +
        '<span class="compare-picker__title">' + escapeHtml(p.title) + '</span>' +
        (p.description
          ? '<span class="compare-picker__desc">' + escapeHtml(p.description) + '</span>'
          : '') +
        '</span></button></li>';
    }).join('');
  }

  function onCheckboxChange(event) {
    var input = event.target;
    if (!input.matches || !input.matches('[data-compare-toggle]')) return;
    if (input.hasAttribute('data-compare-unavailable')) {
      input.checked = false;
      return;
    }

    var product = parseProduct(input);
    if (!product || product.available === false || !isEligibleProduct(product)) {
      input.checked = false;
      return;
    }

    if (input.checked) {
      var result = CompareStore.add(product);
      if (!result.ok) {
        input.checked = false;
        if (result.reason === 'max') {
          announce((window.compareI18n && window.compareI18n.maxReached) ||
            'You can compare up to 4 products.');
        }
        syncCheckboxes(result.items);
        return;
      }
      if (isProductPage()) {
        window.location.assign(compareProductsPageUrl());
      }
    } else {
      CompareStore.remove(product.id);
    }
  }

  function hideBarIfEmpty() {
    if (CompareStore.count() > 0) return false;
    var bar = document.querySelector('[data-compare-bar]');
    if (!bar) return true;
    bar.hidden = true;
    bar.classList.remove('is-visible', 'is-drawer-open', 'is-collapsed');
    closePicker();
    updateBarOffset();
    syncCompareOverlays();
    return true;
  }

  function cartRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function addCompareVariantToCart(variantId, button) {
    if (!variantId || !button || button.disabled) return;

    var root = cartRoot();
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');

    var sectionsToBundle = ['variant-added'];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
      bubbles: true,
      detail: { sections: sectionsToBundle }
    }));

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1 }],
        sections: sectionsToBundle.join(','),
        sections_url: root + 'variants/' + variantId
      })
    })
      .then(function (response) {
        return response.json().then(function (json) {
          return { ok: response.ok, json: json };
        });
      })
      .then(function (result) {
        if (!result.ok) {
          throw new Error((result.json && result.json.description) || 'Add to cart failed');
        }
        return fetch(root + 'cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cartContent) {
            cartContent.sections = result.json.sections || {};
            var items = result.json.items || [result.json];

            document.documentElement.dispatchEvent(new CustomEvent('variant:add', {
              bubbles: true,
              detail: { items: items, cart: cartContent }
            }));
            document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
              bubbles: true,
              detail: { baseEvent: 'variant:add', cart: cartContent }
            }));
          });
      })
      .catch(function () {
        announce((window.compareI18n && window.compareI18n.addToCartError) ||
          'Could not add product to cart.');
      })
      .then(function () {
        button.disabled = false;
        button.removeAttribute('aria-busy');
      });
  }

  function onClick(event) {
    var atcBtn = event.target.closest('[data-compare-atc]');
    if (atcBtn) {
      event.preventDefault();
      addCompareVariantToCart(atcBtn.getAttribute('data-compare-atc'), atcBtn);
      return;
    }

    var clearBtn = event.target.closest('[data-compare-clear]');
    if (clearBtn) {
      event.preventDefault();
      CompareStore.clear();
      closeDrawer();
      closePicker();
      hideBarIfEmpty();
      return;
    }

    var collapseBtn = event.target.closest('[data-compare-collapse]');
    if (collapseBtn) {
      event.preventDefault();
      closeDrawer();
      hideBarIfEmpty();
      return;
    }

    var toggleBtn = event.target.closest('[data-compare-bar-toggle]');
    if (toggleBtn) {
      var bar = document.querySelector('[data-compare-bar]');
      if (!bar) return;
      if (isDrawerOpen()) {
        closeDrawer();
        hideBarIfEmpty();
      } else {
        var collapsed = bar.classList.toggle('is-collapsed');
        toggleBtn.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
        updateBarOffset();
        syncCompareOverlays();
      }
      return;
    }

    var submitBtn = event.target.closest('[data-compare-submit]');
    if (submitBtn && !submitBtn.disabled) {
      event.preventDefault();
      openDrawer();
      return;
    }

    var removeBtn = event.target.closest('[data-compare-remove]');
    if (removeBtn) {
      event.preventDefault();
      CompareStore.remove(removeBtn.getAttribute('data-compare-remove'));
      return;
    }

    var openPickerBtn = event.target.closest('[data-compare-open-picker]');
    if (openPickerBtn && !event.target.closest('[data-compare-picker]')) {
      event.preventDefault();
      var idx = Number(openPickerBtn.getAttribute('data-slot-index'));
      if (Number.isNaN(idx)) idx = CompareStore.count();
      var fromCompact = !!openPickerBtn.closest('[data-compare-compact], .compare-bar__add');
      var host = normalizePickerHost(openPickerBtn) ||
        openPickerBtn.closest('[data-compare-slot], [data-compare-product-slot], .empty___cell, .compare-bar__product--empty') ||
        openPickerBtn.parentElement;
      var existing = host && host.querySelector('[data-compare-picker]:not([hidden])');
      if (existing && activeSlotIndex === idx && isDrawerOpen()) {
        closePicker();
        return;
      }

      if (fromCompact && !isDrawerOpen()) {
        if (isCompareProductsPage()) {
          openPicker(idx, host);
          return;
        }
        openDrawer({ minCount: 1, keepPicker: true });
        requestAnimationFrame(function () {
          var drawerHost = document.querySelector(
            '[data-compare-product-slot][data-slot-index="' + idx + '"] .empty___cell, ' +
            '[data-compare-product-slot][data-slot-index="' + idx + '"] .compare-bar__product--empty'
          ) || document.querySelector(
            '[data-compare-product-slot][data-slot-index="' + idx + '"]'
          );
          openPicker(idx, drawerHost || host);
          updateBarOffset();
        });
        return;
      }

      openPicker(idx, host);
      return;
    }

    var closePickerBtn = event.target.closest('[data-compare-close-picker]');
    if (closePickerBtn) {
      event.preventDefault();
      closePicker();
      return;
    }

    var pickBtn = event.target.closest('[data-compare-pick]');
    if (pickBtn) {
      event.preventDefault();
      var lockedScrollY = comparePageScrollLocked ? comparePageScrollLockY : window.scrollY;
      var scrollX = window.scrollX;
      var pickId = pickBtn.getAttribute('data-compare-pick');
      var product = getCatalog().find(function (p) { return String(p.id) === String(pickId); });

      closePicker();

      if (product && product.available !== false) {
        var addResult = CompareStore.add(normalizeProduct(product));
        if (!addResult.ok && addResult.reason === 'max') {
          announce((window.compareI18n && window.compareI18n.maxReached) ||
            'You can compare up to 4 products.');
        }
      }

      restoreComparePageScroll(scrollX, lockedScrollY);
      return;
    }

    if (!event.target.closest('[data-compare-picker]') &&
        !event.target.closest('[data-compare-open-picker]')) {
      closePicker();
    }
  }

  function onSearchInput(event) {
    if (!event.target.matches('[data-compare-search]')) return;
    renderPickerResults(event.target.value);
  }

  function onKeydown(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      var emptySlot = event.target.closest('.empty___cell[data-compare-open-picker], .compare-bar__product--empty[data-compare-open-picker]');
      if (emptySlot) {
        event.preventDefault();
        emptySlot.click();
        return;
      }
    }
    if (event.key === 'Escape') {
      if (document.querySelector('[data-compare-picker]:not([hidden])')) {
        closePicker();
        return;
      }
      if (isDrawerOpen()) {
        closeDrawer();
        hideBarIfEmpty();
      }
    }
  }

  function refresh(items) {
    items = pruneIneligible((items || CompareStore.get()).map(normalizeProduct));
    syncCompareCheckboxVisibility();
    syncCheckboxes(items);
    renderBar(items);
  }

  function init() {
    document.addEventListener('change', onCheckboxChange);
    document.addEventListener('click', onClick);
    document.addEventListener('input', onSearchInput);
    document.addEventListener('keydown', onKeydown);
    document.addEventListener(CHANGE_EVENT, function (e) {
      refresh(e.detail && e.detail.items);
    });
    window.addEventListener('storage', function (e) {
      if (e.key === STORAGE_KEY) refresh();
    });
    window.addEventListener('resize', function () {
      updateBarOffset();
      syncEmptyProductHeights();
      positionActivePicker();
      syncStickyProductRowState();
      syncPageHeaderStickyState(true);
    });
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', positionActivePicker, { passive: true });
      window.visualViewport.addEventListener('scroll', positionActivePicker, { passive: true });
    }
    window.addEventListener('scroll', function () {
      syncStickyProductRowState();
      syncPageHeaderStickyState();
    }, { passive: true });
    document.addEventListener('scroll', positionActivePicker, true);
    refresh();
    if (isCompareProductsPage()) {
      initComparePage();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
